import React from 'react'
import { Container, Row } from 'reactstrap'
import MedicineTable from './MedicineTable'


export default function MedicineStatus() {
  return (
    <>
      <Container fluid>
        <Row>
<MedicineTable/>
        </Row>
      </Container>
    </>
  )
}